import { Component, OnInit } from '@angular/core';
import { HospitalService } from '../../_service/hospital.service';
import { DoctorService } from '../../_service/doctor.service';
import { LeadsService } from '../../_service/leads.service';
import { SharedService } from '../../_service/shared.service';
import { ActivatedRoute, Router  } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { MiscService } from 'src/app/_service/misc.service';
import { ConfirmationModalComponent } from '../../common/confirmation-modal/confirmation-modal.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
declare var $: any;
@Component({
  selector: 'app-add-edit-hospital',
  templateUrl: './add-edit-hospital.component.html',
  styleUrls: ['./add-edit-hospital.component.css']
})
export class AddEditHospitalComponent implements OnInit {
  public Editor = ClassicEditor;
  hospitalForm: FormGroup;submitted = false;loading:boolean=false;cities=[];passwordhide:boolean = true;HospitalId: any = '';uploading:boolean=false;myrole:string;
  allUploads=[];s3url='';doc_type:string='';doc_file:string='';circles=[];hospital_city:boolean=true;circles_copy=[];cities_copy=[];allow_multiple:boolean=false; selectedFiles=[];
  treatmentcostForm: FormGroup; treatments=[];treatments_copy=[];hospitalName:string;TreatmentcostList=[];activeTab='0';treatmentcost:boolean=false;treatmentcostId:any;treatCategory=[]; locality=[];locality_copy=[];amenity=[];amenity_copy=[];
  doctors=[];doctors_copy=[];hospital_logo_img:any;
    constructor(private hospitalapi:HospitalService,private router:Router,private sharedapi:SharedService,private formBuilder: FormBuilder,public leadapi:LeadsService,private activatedRoute: ActivatedRoute,private doctorapi:DoctorService,public miscapi:MiscService,private dialog: MatDialog)
    {   
        this.sharedapi.getRole()
        .subscribe((item:string) => {this.myrole=item;});
        this.myrole = localStorage.getItem('role');
        this.getcircle();
        this.getTreatment();
        this.getTreatmentCategory();
        this.getDoctor();
        let contactPattern = "[[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*]*";
        let vaildEmailAddress: any = "^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@" + "[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$";
        let passwordPattern = "^[a-zA-Z0-9]{8,}$";

        this.hospitalForm = this.formBuilder.group({ 
            'mobile' : [null, Validators.compose([Validators.required, Validators.pattern(contactPattern)])],
            'email': [null, Validators.compose([Validators.required, Validators.pattern(vaildEmailAddress)])],
            'name' : [null, Validators.required],
            'status' : [null, Validators.required],
            'circle_id' : [null, Validators.required],
            'city_id' : [null, Validators.required],
            'address' : [null, Validators.required],
            'location' : [null, Validators.required],
            'location_name' : [null, Validators.required],
            'hospital_rating' : [null],
            'hospital_review' : [null],
            'about_hospital' : [null],
            'hospital_services' : [null],
            'hospital_url_slug' : [null],
            'password': [null, Validators.compose([Validators.required, Validators.pattern(passwordPattern)])],
            'display_name' : [null],
            'hospital_type' : [null],
            'featured_speciality' : [null],
            'top_treatments' : [null],
            'latitude' : [null],
            'longitude' : [null],
            'localities_id' : [null],
            'amenities_id' : [null],
            'hospital_timing' : [null],
            'doctor_id' : [null],
            'hospital_logo' : [null],
            'display_number' : [null],
            'payment_accepted' : [null],
            'full_description' : [null],
            'meta_title' : [null],
            'meta_description' : [null],
            'og_title' : [null],
            'og_description' : [null]
        });


        this.treatmentcostForm = this.formBuilder.group({ 
            'treatment_id' : [null, Validators.required],
            'price' : [null, Validators.required],
            'hospital_id': [null],
            'price_range':[null]
        });

        this.activatedRoute.params.subscribe(params => {
            if (params['hospital_id']) {
                this.HospitalId = params['hospital_id'];
                this.patchHospitalData();
                this.getHospitalTreatmentcostList();
                const userPass = this.hospitalForm.get('password');
                userPass.clearValidators();
                userPass.updateValueAndValidity();
            }

        });

    }

    get f() { return this.hospitalForm.controls; }
    get t() { return this.treatmentcostForm.controls; }

    setSearchValue(type){
        if(type=='circle'){
            $("#circleSearch").val('');
            $("#circleSearch").focus();
            this.circles= this.circles_copy;
        }else if(type=='city'){
            $("#citySearch").val('');
            $("#citySearch").focus();
            this.cities= this.cities_copy;
        }
        else if(type=='treatment'){
            $("#treatmentSearch").val('');
            $("#treatmentSearch").focus();
            this.treatments= this.treatments_copy;
        } else if(type=='localities'){
            $("#localitiesSearch").val('');
            $("#localitiesSearch").focus();
            this.locality= this.locality_copy;
        } else if(type=='amenities'){
            $("#amenitiesSearch").val('');
            $("#amenitiesSearch").focus();
            this.amenity= this.amenity_copy;
        } else if(type=='doctor'){
            $("#doctorSearch").val('');
            $("#doctorSearch").focus();
            this.doctors= this.doctors_copy;
        }
    }

    searchOnSelect(searchtText: string, type){
        if (type == 'circle') {
            this.circles = this.sharedapi.searchData(searchtText, this.circles_copy, "name");
        }else if(type == 'cities'){
            this.cities = this.sharedapi.searchData(searchtText, this.cities_copy, "name");
        }else if(type == 'treatment'){
            this.treatments = this.sharedapi.searchData(searchtText, this.treatments_copy, "name");
        }else if(type == 'localities'){
            this.locality = this.sharedapi.searchData(searchtText, this.locality_copy, "name");
        }else if(type == 'amenities'){
            this.amenity = this.sharedapi.searchData(searchtText, this.amenity_copy, "name");
        }else if(type == 'doctor'){
            this.doctors = this.sharedapi.searchData(searchtText, this.doctors_copy, "name");
        }
    }

    async getTreatment()
    {
        await this.leadapi.getTreatments().subscribe((data:any) => {
            if(data.status)
            {
                this.treatments = data.data;
                this.treatments_copy= this.treatments;
            }else{
                this.treatments = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getcircle()
    {
        await this.leadapi.getcircles().subscribe((data:any) => {
            if(data.status)
            {
                this.circles = data.data;
                this.circles_copy = this.circles;
            }else{
                this.circles = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }
    

    async getCircleCities(circle_id)
    {
        let qString = 'circle='+circle_id;
        await this.doctorapi.getCircle_cities(qString).subscribe((data:any) => {
            if(data.status)
            {
                this.cities = data.data;
                this.cities_copy = this.cities;
                this.hospital_city=false;
            }else{
                this.cities = [];
                this.hospital_city=false;
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    ngOnInit(): void 
    {
        this.s3url = localStorage.getItem('s3url');  
        this.getLocality();
        this.getAmenity();
    }

    showPassword() {
        this.passwordhide = !this.passwordhide;
    }

    Allow_multiple(){
        // console.log(this.doc_type);
        if(this.doc_type=='7'){
            this.allow_multiple=true;
        }else{
            this.allow_multiple=false;
        }
    }

    async selectFile(event)
    {
        if(this.doc_type!=undefined)
        {
            this.uploading = true;
            // let file = event.target.files.item(0);
            
            const formData = new FormData(); 
            formData.append('upload_type',this.doc_type); 
            if(this.allow_multiple){
                this.selectedFiles = event.target.files;
                
            }else{
                this.selectedFiles = event.target.files;
                //formData.append('file[]', this.selectedFiles[0]);
            }

            for (var i = 0; i < this.selectedFiles.length; i++) { 
                formData.append("file[]", this.selectedFiles[i]);
            }

            await this.hospitalapi.uploadHospitalFile(this.HospitalId,formData)
            .subscribe((data:any) => {
                this.uploading = false;
                if(data.status)
                {
                    this.sharedapi.presentToast('File uploaded Successful');
                    this.patchHospitalData();
                }
                else
                {
                    this.sharedapi.presentToast(data.msg);
                }
              }, error => 
                {
                    this.uploading = false;
                    this.sharedapi.checkError(error);
                });
        }else{
            this.sharedapi.presentToast('Please select Document Type');
        }
    }

    async patchHospitalData(){
        
        await this.hospitalapi.getHospitalData(this.HospitalId).subscribe((response:any) => {
           if(response.status){
            this.getCircleCities(response.data.circle_id)
            this.allUploads = response.uploads;
             this.hospital_logo_img = response.data.hospital_logo;
               this.hospitalForm.patchValue({
                 'name':response.data.name,  
                 'mobile':response.data.mobile,  
                 'email':response.data.email,  
                 'status':response.data.status,  
                 'city_id':response.data.city_id,
                 'circle_id':response.data.circle_id,
                 'address':response.data.address,
                 'location':response.data.location,
                 'location_name':response.data.location_name,
                 'hospital_rating' : response.data.hospital_rating,
                 'hospital_review' : response.data.hospital_review,
                 'about_hospital' : response.data.about_hospital,
                 'hospital_url_slug' : response.data.hospital_url_slug,
                 'hospital_services' : response.data.hospital_services,
                 'display_name' : response.data.display_name,
                 'hospital_type' : response.data.hospital_type,
                 'featured_speciality' : response.data.featured_speciality,
                 'top_treatments' : response.data.top_treatments,
                 'latitude' : response.data.latitude,
                 'longitude' : response.data.longitude,
                 'localities_id': response.data.localities_id,
                 'amenities_id': response.data.amenities_id,
                 'hospital_timing' : response.data.hospital_timing,
                 'doctor_id' : response.data.available_doctors,
                 'display_number' : response.data.display_number,
                 'payment_accepted' : response.data.payment_accepted,
                 'full_description' : response.data.full_description,
                 'meta_title' : response.data.meta_title,
                 'meta_description' : response.data.meta_description,
                 'og_title' : response.data.og_title,
                 'og_description' : response.data.og_description
               })
               this.doc_type='';
               this.doc_file='';
               this.hospitalName= response.data.name;
            //    this.treatmentcostForm.patchValue({
            //     'hospital_id':this.HospitalId  
            //     })
           }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async createHospital(){
        this.submitted = true;
        this.loading = true;
        // stop here if form is invalid
        if (this.hospitalForm.invalid) {
            this.loading = false;
            return;
        }
        //For Update Hospital...//
        if(this.HospitalId){
        this.hospitalForm.value.id= parseInt(this.HospitalId); 
        this.hospitalapi.updateHospital(this.hospitalForm.value)
        .subscribe((data:any) => {
            this.submitted = false;
            this.loading = false;
            if(data.status)
            {
                this.sharedapi.presentToast('Hospital Update Successfully');
            }
            else
            {
                this.sharedapi.presentToast(data.msg);
            }
          }, error => 
            {
                this.sharedapi.checkError(error);
            });  
        }else{ 
            //For Add Hospital//
          await this.hospitalapi.addHospital(this.hospitalForm.value)
         .subscribe((data:any) => {
            this.submitted = false;
            this.loading = false;
            if(data.status)
            {
                this.sharedapi.presentToast('Hospital Added Successfully');
                this.HospitalId= data.lastId;
                this.patchHospitalData();
            }
            else
            {
                this.sharedapi.presentToast(data.msg);
            }
          }, error => 
            {
                this.sharedapi.checkError(error);
            }); 
        }
    }

    async getHospitalTreatmentcostList(){
        await this.hospitalapi.getTreatmentcostList(this.HospitalId).subscribe((data:any) => {
            if(data.status)
            {
                this.TreatmentcostList = data.data;
            }else{
                this.TreatmentcostList = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    resetForm(){
        this.treatmentcost=false;
        this.submitted=false;
        this.treatmentcostForm.reset();
    }

    fetchTreatCostData(id){
        this.treatmentcostId=id;
        this.hospitalapi.getTreatCostData(id).subscribe((response:any) => {
            if(response.status){
                this.treatmentcost=true;
                this.treatmentcostForm.patchValue({
                    'treatment_id':response.data.treatment_id,
                    'price':response.data.price,
                    'price_range':response.data.price_range
                })
            }
            
        }, error => {
            this.sharedapi.checkError(error);
        });
    }


    async createHospitalTreatcost(){
        console.log(this.treatmentcostForm);
        this.submitted = true;
        this.loading = true;
        // stop here if form is invalid
        if (this.treatmentcostForm.invalid) {
            this.loading = false;
            return;
        }
        this.treatmentcostForm.value.hospital_id= parseInt(this.HospitalId); 

        console.log(this.treatmentcostForm);
        //return false;
        if(this.treatmentcost){
            this.treatmentcostForm.value.id= parseInt(this.treatmentcostId); 
                this.hospitalapi.updateTreatmentCost(this.treatmentcostForm.value)
                .subscribe((data:any) => {
                this.submitted = false;
                this.loading = false;
                    if(data.status)
                    {
                        this.sharedapi.presentToast('Treatment Cost Updated Successfully');
                        this.getHospitalTreatmentcostList();
                    }
                    else
                    {
                        this.sharedapi.presentToast(data.msg);
                    }
                }, error => 
                {
                    this.sharedapi.checkError(error);
                });  
        }else{
                this.hospitalapi.addTreatmentCost(this.treatmentcostForm.value)
                .subscribe((data:any) => {
                this.submitted = false;
                this.loading = false;
                if(data.status)
                {
                    this.sharedapi.presentToast('Treatment Cost Added Successfully');
                    this.getHospitalTreatmentcostList();
                    this.activeTab='1'; 
                    this.treatmentcostForm.reset();
                }
                else
                {
                    this.sharedapi.presentToast(data.msg);
                }
                }, error => 
                {
                    this.sharedapi.checkError(error);
                }); 
            }
        
    }

    async getTreatmentCategory()
    {
        await this.miscapi.getTreat_Category().subscribe((data:any) => {
            if(data.status)
            {
                this.treatCategory = data.data;
            }else{
                this.treatCategory = [];
                this.sharedapi.presentToast(data.msg);
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }
    async getLocality()
    {
        await this.hospitalapi.getLocalities().subscribe((data:any) => {
            if(data.status)
            {
                this.locality = data.data;
                this.locality_copy =this.locality;
            }else{
                this.locality = [];
                this.sharedapi.presentToast(data.msg);
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getAmenity()
    {
        await this.hospitalapi.getAmenities().subscribe((data:any) => {
            if(data.status)
            {
                this.amenity = data.data;
                this.amenity_copy = this.amenity;
            }else{
                this.amenity = [];
                this.sharedapi.presentToast(data.msg);
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getDoctor()
    {
        await this.leadapi.getdoctors().subscribe((data:any) => {
            if(data.status)
            {
                this.doctors = data.data;
                this.doctors_copy= this.doctors;
            }else{
                this.doctors = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }
    selectHospitalLogo(event)
    {
        const file = (event.target as HTMLInputElement).files[0];
        this.hospitalForm.patchValue({
            hospital_logo: file
        });
        this.hospital_logo_img='';
    }

 //-----------------------------------Delete hospital document Data---------------------------------------//
 RemoveDoc(doc_id) {
    const dialogRef = this.dialog.open(ConfirmationModalComponent, {
      width: '350px',
      backdropClass: 'backdropBackground',
      data: {
        message: 'Are you sure want to delete?',
        buttonText: {
          ok: 'Confirm',
          cancel: 'No'
        }
      }
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        let data = {
          'id': doc_id
        }
        this.hospitalapi.deleteDocuments(data).subscribe((data: any) => {
          this.loading = false;
          if (data.status) {
            this.sharedapi.presentToast(data.msg);
            this.patchHospitalData();
          }
          else {
            this.sharedapi.presentToast(data.msg);
          }
        }, error => {
          this.sharedapi.checkError(error);
        });

      }
    });
  }

}
